module.exports = __webpack_public_path__ + "static/media/C.4ba784cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/C.svg
// module id = 290
// module chunks = 0